import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const ReportNewForm = lazy(() => import('@components/Report/ReportNewForm'));

/** 기업 보고자료 관리 > 등록 */
const ReportNew = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <ReportNewForm />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default ReportNew;
